/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/

/**
 * Product admin page.
 */
export const product_admin_page = {
    hierarchy: 'cif:products',
    name: 'products',
    type: 'collection',
    assetId: undefined
};

/**
 * Product properties page.
 */
export const product_properties_page = {
    hierarchy: 'cif:products:product',
    name: 'properties',
    type: 'properties'
};

/**
 * Category properties page.
 */
export const category_properties_page = {
    hierarchy: 'cif:products:category',
    name: 'properties',
    type: 'properties'
};
